import { render, staticRenderFns } from "./CompareSessions.vue?vue&type=template&id=68d17712&scoped=true&"
import script from "./CompareSessions.vue?vue&type=script&lang=ts&"
export * from "./CompareSessions.vue?vue&type=script&lang=ts&"
import style0 from "../criteriaStation.css?vue&type=style&index=0&id=68d17712&scoped=true&lang=css&"
import style1 from "./CompareSessions.vue?vue&type=style&index=1&id=68d17712&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d17712",
  null
  
)

export default component.exports